<div class="container">
  <mat-form-field appearance="fill" style="width:120px">
    <mat-label>{{ displayAs }} Code</mat-label>
    <mat-select (selectionChange)="onCodeChange($event)" [(value)]="selectedCode">
      @for (code of timesheetCodes; track code) {
      <mat-option [value]="code">
        {{ code.code }} - {{ code.description }}
      </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>